import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { MaterialComponentsModule } from 'src/app/shared/material.module';
import { NewGoalsInput } from 'src/app/shared/modals/new-goals-input/new-goals-input';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule,
        ReactiveFormsModule,
        PipesModule,
        MaterialComponentsModule,
        NgxMatDatetimePickerModule,
        NgxMatNativeDateModule,
        NgxMatTimepickerModule,
    ],
    declarations: [NewGoalsInput],
    exports: [NewGoalsInput]
})
export class NewGoalsInputModule {
}
